// extracted by mini-css-extract-plugin
module.exports = {"cohort":"DashboardCohort_cohort__3mHyZ","button_return":"DashboardCohort_button_return__1Onjs","button_edit":"DashboardCohort_button_edit__KO2xv"};